export const OPERATIONS_PATH = "/apps/operations";

export const BOOKING_LIST_PATH = `${OPERATIONS_PATH}/booking/list`;
export const getBookingViewPath = (id: string | number) =>
  `${OPERATIONS_PATH}/booking/view/${id}`;

export const PRODUCT_LIST_PATH = `${OPERATIONS_PATH}/product/list`;
export const getProductViewPath = (id: string | number) =>
  `${OPERATIONS_PATH}/product/view/${id}`;

export const SERVICE_LIST_PATH = `${OPERATIONS_PATH}/service/list`;
export const getServiceViewPath = (id: string | number) =>
  `${OPERATIONS_PATH}/service/view/${id}`;

export const DEEPLINK_LIST_PATH = `${OPERATIONS_PATH}/deeplink/list`;
export const getDeeplinkViewPath = (id: string | number, type?: string) =>
  type
    ? `${OPERATIONS_PATH}/deeplink/view/${id}?type=${type}`
    : `${OPERATIONS_PATH}/deeplink/view/${id}`;
